import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AMOUNT } from 'apps/auth/constants/fieldsName';
import { TOP_UP_ACCOUNT } from 'apps/auth/constants/formName';
import { addScript } from 'apps/auth/helpers/DOM';

import TopUpByPlaidSelectBank from './TopUpByPlaidSelectBank';
import TopUpCalc from './TopUpCalc';

const TopUpByPlaid = (props) => {
    useEffect(() => {
        addScript('https://cdn.plaid.com/link/v2/stable/link-initialize.js');
    }, []);

    return (
        <CommonPage backUrl={`/auth/ga/pocket/${props.id}/top-up`} leftCloseIcon hasBottomPanel>
            <TopUpCalc formName={TOP_UP_ACCOUNT} itemTitle={props.itemTitle} amountFieldName={AMOUNT} />
            <FixedBottomPanel>
                <Button
                    type="submit"
                    raised={true}
                    onClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(true, <TopUpByPlaidSelectBank formName={TOP_UP_ACCOUNT} />);
                    }}
                    disabled={props.amountFrom.isError || !props.amountFrom.value || parseFloat(props.amountFrom.value) === 0}
                    caption={props.cardTransferButton}
                />
            </FixedBottomPanel>
        </CommonPage>
    );
};
const mapStateToProps = (state) => {
    return {
        id: state.extra.id,
        account: state.extra.account,
        amountFrom: state.form[TOP_UP_ACCOUNT].fields[AMOUNT],
        cardTransferButton: state.messages.pageMessages.cardTransferButton,
        itemTitle: state.messages.pageMessages.bankAccount,
    };
};

export default connect(mapStateToProps, {
    toggleModal,
})(BasePage(TopUpByPlaid));
